import { Page, PageLink } from "@tfg/ui"
import { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"

export const AdminWrapper = () => {
  const { t } = useTranslation("admin")
  const navigate = useNavigate()
  const { user, isAdmin, homeRedirectUrl } = useAuth()

  useEffect(() => {
    if (!user) {
      void navigate("/login")
      return
    }
    if (!isAdmin) {
      void navigate(homeRedirectUrl)
    }
  }, [navigate, user, isAdmin, homeRedirectUrl])

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("tabs.organizations"),
        link: "organizations",
      },
      {
        label: t("tabs.security"),
        link: "security",
      },
      {
        label: t("tabs.faq"),
        link: "faq",
      },
      {
        label: t("tabs.translations"),
        link: "translations",
      },
      {
        label: t("tabs.masterLists"),
        link: "masterlists",
      },
      {
        label: t("tabs.ingestion"),
        link: "ingestion",
      },
      {
        label: t("tabs.exports"),
        link: "admin-exports",
      },
      {
        label: t("tabs.featureFlags"),
        link: "feature-flags",
      },
      {
        label: t("tabs.mapping"),
        link: "mapping",
      },
      {
        label: t("tabs.ingestionSettings"),
        link: "ingestion-settings",
      },
    ],
    [t]
  )

  return <Page title={t("title")} pages={pages} />
}
